import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthProvider';
import { toast } from 'sonner';
import { useEffect, useState } from 'react';

const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const [hasShownToast, setHasShownToast] = useState(false);
  const token = localStorage.getItem('firebase_id_token');

  useEffect(() => {
    if (!loading && token && user && !user.is_admin && !hasShownToast) {
      toast.error('You do not have admin access');
      setHasShownToast(true);
    }
  }, [loading, token, user, hasShownToast]);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!token) {
    return <Navigate to="/" replace />;
  }

  if (!user || !user.is_admin) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default AdminRoute;

